import { Loader2, RefreshCw } from "lucide-react";

export function WorkspaceLoadState({ busy, onRetry }: { busy: boolean; onRetry: () => void }) {
  return <section className="route-loading" role="status" aria-live="polite">
    {busy ? <><Loader2 className="spin" size={22}/><span>Загружаем данные…</span></> : <>
      <span>Данные пока недоступны</span>
      <button className="ghost" type="button" onClick={onRetry}><RefreshCw size={18}/>Повторить загрузку</button>
    </>}
  </section>;
}
